import http from "../../http-common";
/* eslint-disable */
class McuLayananService {
  mcuLayananList(page, itemPerPage, keyword, id) {
    return http.get(
      "/mcu-layanan/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&mcu_id=" +
        id,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  create(data, id) {
    var bodyFormData = new FormData();
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("nama_en", data.nama_en);
    bodyFormData.append("mcu_id", id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/mcu-layanan", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  update(data, id) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    bodyFormData.append("nama", data.nama);
    bodyFormData.append("nama_en", data.nama_en);
    bodyFormData.append("mcu_id", id);

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/mcu-layanan/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  delete(id) {
    return http.delete(`/mcu-layanan/${id}`, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }
}

export default new McuLayananService();
